module.exports = __webpack_public_path__ + "img/empreendimento-logo-12.fb627f53.png";